// ============================================
// Creator Module - Event Handlers (ES6)
// ============================================
// 이벤트 핸들러가 creator/events/ 폴더로 분리됨
// 이 파일은 하위 호환성을 위한 re-export 역할

// 개별 이벤트 초기화 함수 re-export
export {
  initCreatorTabEvents,
  initSearchModalEvents,
  initStatsModalEvents,
  initCreationTypeModalEvents
} from './creator/events/tab.js';

export { initCharacterEditorEvents } from './creator/events/editor.js';

export { initAutofillModalEvents } from './creator/events/autofill.js';

export {
  initImageGenModalEvents,
  initImageSelectionModalEvents,
  initImageDetailModalEvents
} from './creator/events/image.js';

// 통합 초기화 함수 re-export
export { initAllCreatorEvents } from './creator/events/index.js';

// DOM 로드 완료 시 초기화
import { initAllCreatorEvents } from './creator/events/index.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllCreatorEvents);
} else {
  initAllCreatorEvents();
}
